<!--
 * @Description: 主容器
                        问题：noLayout的路由为缓存，如果需要缓存需要注册容器组件router-transition
 * @Date: 2021-09-23 17:33:36
-->
<template>
  <router-view class="router" :style="{ width: '100%', height: baseHeight }" />
</template>
<script lang="ts" setup>
import { onMounted, onUnmounted, ref } from 'vue';
import appStore from '@/store';
import router from '@/router';
import { PLATFORM_IMAGES } from './config';
import { WHITE_LIST } from '@constants/intercept';

// const route = useRoute();

// watch(
//   () => route,
//   v => {
//     console.log('app router change', v);
//   },
//   { deep: true, immediate: true }
// );

const baseHeight = ref('100vh');
const _setScale = () => {
  const screenWidth = window.innerWidth;
  const designWidth = screenWidth < 1200 ? 1200 : 1920;
  let scale = 1;

  if (screenWidth >= designWidth) {
    document.body.style.transform = `scale(${scale})`;
    document.body.style.transformOrigin = '0 0';
    document.body.style.width = `${window.innerWidth}px`;
    document.body.style.height = `${window.innerHeight}px`;
    document.body.style.position = 'relative';

    baseHeight.value = '100vh';
  } else {
    scale = screenWidth / designWidth;
    document.body.style.transform = `scale(${scale})`;
    document.body.style.transformOrigin = '0 0';
    document.body.style.width = `${designWidth}px`;
    document.body.style.height = `${window.innerHeight}px`;
    document.body.style.position = 'relative';

    baseHeight.value = `${window.innerHeight / scale}px`;
  }
};

/**
 * 创建favicon
 */
const createFavicon = () => {
  const link = (document.querySelector("link[rel*='icon']") ||
    document.createElement('link')) as any;
  link.type = 'image/x-icon';
  link.rel = 'shortcut icon';
  link.href = PLATFORM_IMAGES['favicon'];
  document.getElementsByTagName('head')[0].appendChild(link);
};

onMounted(() => {
  createFavicon();
  // 独立页（白名单，如 PC 答题）跳过主应用初始化调用链
  if (!WHITE_LIST.includes(router.currentRoute.value.path)) {
    appStore.useUserStoreSetup.initUserSystemData();
  }

  // setScale();
  // window.addEventListener('resize', setScale);
});
onUnmounted(() => {
  // window.removeEventListener('resize', setScale);
});

console.log('启动方式：', process.env.NODE_ENV);
console.log('启动环境：', process.env.VUE_APP_SCENE);
console.log('启动版本：', process.env.VERSION);
console.log('接口域名：', process.env.PROXY);
console.log('Cors：', process.env.DOMAIN);
</script>
<style lang="scss">
@import '~@/styles/unqualified.scss';
@import '~@/styles/theme.scss';
@import '~@/styles/function.scss';

:root {
  $primary: $--theme-color;
  --xrk-color-primary: #{$primary} !important;
  @for $i from 1 through 9 {
    --xrk-color-primary-light-#{$i}: #{primary-light($primary, $i)} !important;
  }
  @for $i from 1 through 3 {
    --xrk-color-primary-dark-#{$i}: #{primary-dark($primary, $i)} !important;
  }
}
</style>
